import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges} from '@angular/core';
import {ObjectIdentifier} from "../../../../../core/shared/basic/object-identifier";
import {DtoImportObjectContext} from "../../../../../core/shared/dto/dto.import.object.context";
import {DtoDetail} from "../../../../../core/shared/dto/dto.detail";
import {ObjectChangeInformation} from "../../../../../core/shared/logic/object-change-information";
import {WidgetData} from "../../../../../core/shared/widget/widget-data";
import {WidgetFactory} from "../../../../../core/shared/widget/service/widget.factory";
import {WidgetDataParam} from "../../../../../core/shared/widget/widget-data-param";
import {MvsFormControlOverwrite} from "../../../../../core/shared/logic/form/logic/mvs-form-control-overwrite";
import {MvsFormFieldAccessEnum} from "../../../../../core/shared/logic/form/logic/mvs-form-field-access.enum";
import {CustomerInsurableObjectDto} from "../../../../cr/model/dto/entity/customer-insurable-object.dto";

@Component({
    selector: 'cm-update-insurable-object',
    templateUrl: './cm-update-insurable-object.component.html',
    standalone: false
})
export class CmUpdateInsurableObjectComponent
    implements OnInit {

    @Input() customerId: number;
    @Input() insurableObjectId: number;
    @Input() objectIdentifier: ObjectIdentifier;
    @Input() importObjectContext: DtoImportObjectContext;
    @Input() defaultCreateDto: DtoDetail;

    @Output() onChangedObject = new EventEmitter<ObjectChangeInformation>();

    customerInsurableObjectForm: WidgetData;
    insurableObjectForm: WidgetData;

    busy: boolean;  // indicator whether the component is busy
    initialized: boolean; // indicator whether the component was initialized

    constructor() {
    }

    ngOnInit(): void {
        this.initComponent();
    }
    /**
     * Initialize Component.
     */
    initComponent() {
        this.refreshComponent();
    }

    /**
     * Refresh Component.
     */
    refreshComponent() {
        this.showWidgets();
        this.initialized = true;
    }

    showWidgets() {
        this.showCustomerInsurableObjectForm();
        this.showInsurableObjectForm();
    }

    showCustomerInsurableObjectForm() {

        const defaultDto = new CustomerInsurableObjectDto();
        defaultDto.customerDtoId = this.customerId;
        defaultDto.insurableObjectDtoId = this.insurableObjectId;

        const formControlOverwrite = new MvsFormControlOverwrite();
        formControlOverwrite.addField('id', MvsFormFieldAccessEnum.HIDDEN);
        formControlOverwrite.addField('customerDtoId', MvsFormFieldAccessEnum.HIDDEN);
        formControlOverwrite.addField('insurableObjectDtoId', MvsFormFieldAccessEnum.HIDDEN);

        this.customerInsurableObjectForm = WidgetFactory.createWidgetObject(
            "cm.update.customer.insurable.object.form.customer.new",
            "Versichertes Objekt am Kunden",
            this.objectIdentifier.objectType,
            this.objectIdentifier.objectId,
            WidgetDataParam.create('createDefaultDto', defaultDto),
            WidgetDataParam.create('formControlOverwrite', formControlOverwrite)
        );

    }

    showInsurableObjectForm() {
        this.insurableObjectForm = WidgetFactory.createWidgetObject(
            "cm.update.insurable.object.form.object.new",
            "Versichertes Objekt",
            'ci.InsurableObject',
            this.insurableObjectId);

    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes["id"]) {
            this.refreshComponent();
        }
    }
    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }

    handleChangedObject(event: ObjectChangeInformation) {
        this.onChangedObject.emit(event);
    }

}
